import { apiFetch } from "./client";

const withActorHeaders = (actor = {}) => {
  const headers = {};
  if (actor.role) headers["x-actor-role"] = actor.role;
  if (actor.id) headers["x-actor-id"] = actor.id;
  return headers;
};

const listLeaves = async (params = {}, actor = {}) => {
  const search = new URLSearchParams();
  if (params.employeeId) search.set("employeeId", params.employeeId);
  if (params.type) search.set("type", params.type);
  if (params.status) search.set("status", params.status);
  if (params.from) search.set("from", params.from);
  if (params.to) search.set("to", params.to);
  const query = search.toString();
  const url = query ? `/api/leaves?${query}` : "/api/leaves";
  return apiFetch(url, { headers: withActorHeaders(actor) });
};

const createLeave = async (payload, actor = {}) =>
  apiFetch("/api/leaves", {
    method: "POST",
    body: JSON.stringify({
      ...payload,
      actorId: actor.id,
      actorRole: actor.role,
    }),
    headers: withActorHeaders(actor),
  });

const updateLeave = async (id, payload, actor = {}) =>
  apiFetch(`/api/leaves/${id}`, {
    method: "PATCH",
    body: JSON.stringify({
      ...payload,
      actorId: actor.id,
      actorRole: actor.role,
    }),
    headers: withActorHeaders(actor),
  });

const getLeave = async (id, actor = {}) => apiFetch(`/api/leaves/${id}`, { headers: withActorHeaders(actor) });

export { listLeaves, createLeave, updateLeave, getLeave };
